/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './resolveDid.defs.js'
export * as $defs from './resolveDid.defs.js'
